import React, {useMemo, useRef} from 'react'
import OverlayComponent from '../../components/overlay'
import useLeapOverlay from '../../hooks/useOverlay'
import {hasValidAsset, hasValidString} from '../../utils/utils'
import {Box, Flex, useSlotRecipe} from '@chakra-ui/react3'
import Asset from '../../components/cms/asset'
import ButtonGroup from '../../components/cms/button-group'
import CTA from '../../components/cms/cta'
import overlayModuleRecipe from './index.recipe'
import PropTypes from 'prop-types'
import RichText from '../../components/cms/rich-text'

const Overlay = ({
    anchor,
    title,
    paragraphs,
    asset,
    firstCta,
    secondCta,
    background,
    loading = 'lazy'
}) => {
    const {isOpen, onClose} = useLeapOverlay({anchor})

    const recipe = useSlotRecipe({recipe: overlayModuleRecipe})
    const styles = useMemo(() => recipe({}), [recipe])

    const hasFirstCtaLabel = hasValidString(firstCta?.label)
    const hasSecondCtaLabel = hasValidString(secondCta?.label)

    const videoRef = useRef(null)

    return (
        <OverlayComponent isOpen={isOpen} onClose={onClose} background={background} title={title}>
            <Flex css={styles.root}>
                {hasValidAsset(asset) && (
                    <Box css={styles.imageContainer}>
                        <Asset
                            asset={asset}
                            videoRef={videoRef}
                            loading={loading}
                            objectFit="cover"
                            widths={{base: '82vw', s: '81vw'}}
                        />
                    </Box>
                )}

                <Flex css={styles.container}>
                    {paragraphs?.length &&
                        paragraphs.map((el, index) => (
                            <Flex key={index} css={styles.textContainer}>
                                {el.headline && (
                                    <RichText css={styles.headline}>{el.headline}</RichText>
                                )}
                                {el.copy?.text && (
                                    <RichText css={styles.copy}>{el.copy.text}</RichText>
                                )}
                            </Flex>
                        ))}

                    {(hasFirstCtaLabel || hasSecondCtaLabel) && (
                        <ButtonGroup {...styles.buttonGroup}>
                            {hasFirstCtaLabel && <CTA {...firstCta} />}
                            {hasSecondCtaLabel && <CTA {...secondCta} />}
                        </ButtonGroup>
                    )}
                </Flex>
            </Flex>
        </OverlayComponent>
    )
}

export default Overlay

Overlay.propTypes = {
    anchor: PropTypes.string,
    title: PropTypes.string,
    paragraphs: PropTypes.array,
    asset: PropTypes.object,
    firstCta: PropTypes.object,
    secondCta: PropTypes.object,
    background: PropTypes.string,
    loading: PropTypes.string
}
